import Vuex from 'vuex'
import Vue from 'vue'
import User from './user'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
      systemName: 'xyt wxweb'
    },
    modules: {
      User
    }
  })



// WEBPACK FOOTER //
// ./src/store/index.js